module.exports = __webpack_public_path__ + "static/media/notFound.21e335a4.png";